import(/* webpackMode: "eager" */ "/codebuild/output/src3440664837/src/patient-app/app/global-error.tsx");
